import React from "react"
import { ChevronExpandIcon, ChevronUpIcon, ChevronDownIcon } from "components/Elements/Icons"

export const TableHeader = ({ headerGroups, isSortable = true }) => {
	const getOrderIcon = (column) => {
		if (column?.hideSortIcon) return <></>
		return column.isSorted ? (
			column.isSortedDesc ? (
				<ChevronDownIcon size={17} color="white" />
			) : (
				<ChevronUpIcon size={17} color="white" />
			)
		) : (
			<ChevronExpandIcon size={22} color="white" />
		)
	}

	return (
		<thead>
			{
				// Loop over the header rows
				headerGroups.map((headerGroup) => (
					// Apply the header row props
					<tr className="c-table__row" {...headerGroup.getHeaderGroupProps()}>
						{
							// Loop over the headers in each row
							headerGroup.headers.map((column, index) => (
								// Apply the header cell props
								<th
									className={`c-table__cell w-full p-5 ${column.className || ""}`}
									{...(isSortable &&
										column.getHeaderProps(column.getSortByToggleProps()))}
									key={index}
								>
									<span className="u-ellipsis" style={{ whiteSpace: "pre-wrap" }}>
										{isSortable && getOrderIcon(column)}
										<span className="ml-2 font-semibold">
											{column.render("Header")}
										</span>
									</span>
								</th>
							))
						}
					</tr>
				))
			}
		</thead>
	)
}
